import React from 'react';
import { Page, Card, SkeletonBodyText, ResourceList, ResourceItem, TextStyle, Thumbnail, Layout, Stack } from '@shopify/polaris';
import { Helmet } from 'react-helmet';
import { apiFetch as fetch } from '../common/Helpers';
import { GenieTag } from '../components/GenieTag';
import Cookies from "js-cookie";


function renderPreviewItems(item) {
    const { id, productName, legacyId, productImage, tags } = item;

    return (
        <ResourceItem id={id} url={null} media={
            <Thumbnail source={productImage} alt="image" />
        } onClick={(e) => handleProductItemClick(e, legacyId)}>
            <h3 className="previewProductTitle">
                <TextStyle variation="strong">{productName}</TextStyle>
            </h3>
            <Stack spacing="tight" distribution="leading" alignment="leading">{getTagList(tags)}</Stack>
        </ResourceItem>
    );
}

function handleProductItemClick(e, id) {
    const shopOrigin = Cookies.get("shopOrigin");
    window.open(`https://${shopOrigin}/admin/products/${id}`, '_blank');
}

function getTagList(tags) {
    return tags.map(item => {

        let state = "default";
        if (item.selected) {
            state = "added";
        }

        return <GenieTag selectable={false} state={state}>{item.tagName}</GenieTag>
    });
}

class TagPage extends React.Component {

    constructor(props) {
        super(props);

        const search = props.location.search;
        const queryTagName = new URLSearchParams(search).get('tagName')
        this.state = {
            isLoading: true,
            products: [],
            tagName: queryTagName
        };
    }

    render() {

        let previewItems = this.state.products.map((item, index) => {
            return {
                id: index,
                url: null,
                productName: item.productName,
                productImage: item.productImage,
                tags: item.tags,
                legacyId: item.legacyId
            }
        });

        let title = "Tag - " + this.state.tagName;
        let title2 = "Products tagged with " + this.state.tagName + " - " + this.state.products.length;

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Tag Info</title>
                </Helmet>
                <Page title={title} breadcrumbs={[{ content: 'Dashboard', url: '/' }]}>
                    <Layout>
                        <Layout.Section>
                            {this.state.isLoading && <SkeletonBodyText lines="20" />}
                            {!this.state.isLoading && <Card title={title2} sectioned>
                                <ResourceList
                                    resourceName={{ singular: 'product', plural: 'products' }}
                                    items={previewItems}
                                    renderItem={renderPreviewItems}
                                />
                            </Card>}
                        </Layout.Section>
                    </Layout>
                </Page>
            </div>
        );
    }

    fetchTagProducts = (tag) => {

        fetch(`api/dashboard/tagProducts?tagName=${encodeURIComponent(tag)}`, {
            method: 'GET'
        }).then(response => {
            return response.json()
        }).then(data => this.setState({
            products: data.products,
            isLoading: false
        }));
    }

    componentDidMount() {
        this.fetchTagProducts(this.state.tagName);
    }
}

export default TagPage;